import { ChangeEvent, createRef, useCallback, useRef, DragEvent } from "react";
import DragDrop from "assets/DragDrop.svg";

type DragAndDropVgsSideProps = {
  onFileTypeChange?: (fileType?: string) => void;
  onFileChange: (fileString?: string) => void;
};

export default function DragAndDropVgsSide({
  onFileTypeChange,
  onFileChange,
}: DragAndDropVgsSideProps) {
  const dropRef = createRef<HTMLInputElement>();
  const fileElement = useRef<HTMLInputElement | null>(null);

  const handleFileElementClick = (ev: React.MouseEvent<HTMLInputElement>) => {
    fileElement.current?.click();
  };

  const processFile = useCallback(
    (file?: Blob) => {
      if (!file) {
        onFileChange(undefined);
        onFileTypeChange?.(undefined);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        const contentData = reader.result
          ?.toString()
          .replace(`data:${file.type};base64,`, "");
        onFileTypeChange?.(file.type);
        onFileChange(contentData);
      };
    },
    [onFileChange, onFileTypeChange]
  );

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    processFile(event?.target?.files?.[0] || undefined);
  };

  const handleDragEvent = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropEvent = (e: DragEvent<HTMLDivElement>) => {
    handleDragEvent(e);
    processFile(e.dataTransfer?.files[0] || undefined);
  };

  return (
    <>
      <div
        ref={dropRef}
        className="border-2 border-dashed border-gray-200 flex flex-col justify-center py-3 rounded-lg cursor-pointer"
        onClick={handleFileElementClick}
        onDragEnter={handleDragEvent}
        onDragLeave={handleDragEvent}
        onDragOver={handleDragEvent}
        onDrop={handleDropEvent}
      >
        <img
          src={DragDrop}
          className="h-14"
          alt="Logo for Drag and Drop Feature"
        />
        <p className="lg:flex justify-center text-sm font-medium hidden text-gray-800">
          Drag & Drop File or
        </p>
        <p className="lg:flex justify-center text-sm hidden  ml-2 font-bold text-blue-500">
          Browse
        </p>
        <p className="text-sm font-bold lg:hidden text-blue-500 flex justify-center mt-2">
          Upload File
        </p>
      </div>
      <input
        type="file"
        ref={fileElement}
        className="hidden"
        onChange={handleFileChange}
        accept="application/pdf,image/jpeg,image/png"
      />
    </>
  );
}
